import EzController from 'controllers/ez-base-controller';
import {
  detectIE, isScrolledIntoView, initSvgAnim,
} from 'lib/helpers';
import editorCtaAnimData from 'lib/animation-data/editor-cta-animation-data';

export default class EditorCtaController extends EzController {
  static targets = ['rightCol', 'animContainer']

  connect() {
    this.readyToPlay = true;

    if (!this.animContainerTarget.querySelector('svg')) {
      const anim = initSvgAnim(
        this.animContainerTarget,
        JSON.parse(editorCtaAnimData),
        false, false,
      );

      window.addEventListener('scroll', () => {
        if (isScrolledIntoView(this.animContainerTarget)) {
          if (this.readyToPlay) {
            this.readyToPlay = false;
            anim.play();
          }
        }
      });
    }

    if (detectIE() !== false) {
      window.addEventListener('resize', this.resizeHero);

      setTimeout(this.resizeHero(), 300);
    }
  }

  disconnect() {
    window.removeEventListener('resize', this.resizeHero);
  }

  resizeHero = () => {
    const thisSvg = this.animContainerTarget.querySelector('svg');

    const width = this.animContainerTarget.clientWidth;

    let height = width / 1.46;

    if (height > 500) {
      height = 500;
    }

    this.animContainerTarget.style.height = `${height}px`;

    this.animContainerTarget.parentNode.style.height = `${height}px`;
    thisSvg.style.height = `${height}px`;
  };
}
